import { useEffect } from "react";
import { Instagram } from "lucide-react";

// Real iTMunch reels — add more permalinks here any time.
const REELS = [
  "https://www.instagram.com/p/Degb7RRgUeV/",
  "https://www.instagram.com/p/DdlOeuhRAHz/",
  "https://www.instagram.com/p/Dee1iOAgqRw/",
];

const InstagramEmbed = ({ url }) => (
  <blockquote
    className="instagram-media"
    data-instgrm-permalink={`${url}?utm_source=ig_embed&utm_campaign=loading`}
    data-instgrm-version="14"
    style={{
      background: "#FFF", border: 0, borderRadius: 16, boxShadow: "0 10px 40px -12px rgba(0,0,0,0.5)",
      margin: 0, width: "100%", maxWidth: 360, minWidth: 300,
    }}
  />
);

export const Portfolio = () => {
  useEffect(() => {
    const process = () => window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process();
    if (window.instgrm) { process(); return; }
    const existing = document.getElementById("instagram-embed-js");
    if (existing) { existing.addEventListener("load", process); return; }
    const s = document.createElement("script");
    s.id = "instagram-embed-js";
    s.src = "https://www.instagram.com/embed.js";
    s.async = true;
    s.onload = process;
    document.body.appendChild(s);
  }, []);

  return (
    <section id="portfolio" data-testid="portfolio-section" className="py-16 lg:py-24 bg-[#0C0D14]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="max-w-xl">
          <p className="text-xs font-mono uppercase tracking-widest text-[#00F5D4] mb-3">The proof</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            Reels that actually stopped the scroll
          </h2>
          <a href="https://www.instagram.com/it_munch/" target="_blank" rel="noreferrer"
             data-testid="portfolio-instagram-link"
             className="mt-4 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors">
            <Instagram className="w-4 h-4 text-[#FF2E63]" /> Straight from @it_munch
          </a>
        </div>

        <div data-testid="portfolio-reels-grid"
             className="mt-10 flex flex-wrap justify-center sm:justify-start gap-6">
          {REELS.map((url) => (
            <div key={url} className="w-full max-w-[360px]" data-testid="portfolio-reel-embed">
              <InstagramEmbed url={url} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
